import { motion } from "framer-motion";
import { theme } from "@/theme";
import { useIsMobile } from "@/hooks/use-mobile";

// Mock user data - will be replaced with Supabase data later
const mockUsers = [
  { id: 1, name: "Maria Santos", initials: "MS" },
  { id: 2, name: "James Chen", initials: "JC" },
  { id: 3, name: "Sofia Rodriguez", initials: "SR" },
  { id: 4, name: "Alex Kim", initials: "AK" },
  { id: 5, name: "Emma Wilson", initials: "EW" },
  { id: 6, name: "Diego Martinez", initials: "DM" },
  { id: 7, name: "Lisa Anderson", initials: "LA" },
  { id: 8, name: "Carlos Silva", initials: "CS" },
  { id: 9, name: "Nina Patel", initials: "NP" },
  { id: 10, name: "Lucas Brown", initials: "LB" },
  { id: 11, name: "Anna Lee", initials: "AL" },
  { id: 12, name: "Marco Rossi", initials: "MR" },
  { id: 13, name: "Yuki Tanaka", initials: "YT" },
  { id: 14, name: "Olivia Taylor", initials: "OT" },
  { id: 15, name: "Pedro Garcia", initials: "PG" },
  { id: 16, name: "Zara Khan", initials: "ZK" },
  { id: 17, name: "Tom Anderson", initials: "TA" },
  { id: 18, name: "Maya Johnson", initials: "MJ" },
  { id: 19, name: "Kai Wong", initials: "KW" },
  { id: 20, name: "Isla Murphy", initials: "IM" },
];

const AvatarScroll = () => {
  const isMobile = useIsMobile();
  // Use mock users
  const avatarCount = mockUsers.length;
  
  return (
    <div className="relative overflow-hidden py-6">
      {/* First Row - Scrolling Left */}
      <motion.div
        className="flex gap-4 mb-4"
        animate={{
          x: [0, -1600],
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        {/* Duplicate the array 3 times for seamless endless effect */}
        {[...Array(3)].flatMap((_, set) =>
          mockUsers.map((user, i) => {
            const index = set * avatarCount + i;
            return (
              <motion.div
                key={`avatar-left-${index}`}
                className="w-14 h-14 md:w-20 md:h-20 rounded-full flex-shrink-0 flex items-center justify-center font-bold text-sm md:text-base relative group cursor-pointer"
                style={{
                  background: `linear-gradient(135deg, #E67E22 0%, #F39C12 100%)`,
                  border: `2px solid rgba(230, 126, 34, 0.4)`,
                  color: theme.colors.text,
                  boxShadow: `0 4px 12px rgba(230, 126, 34, 0.3), inset 0 1px 0 rgba(255,255,255,0.1)`,
                }}
                whileHover={{
                  scale: 1.1,
                  boxShadow: `0 6px 20px rgba(230, 126, 34, 0.5)`,
                }}
                transition={{ duration: 0.2 }}
                title={user.name}
              >
                {user.initials}
              </motion.div>
            );
          })
        )}
      </motion.div>

      {/* Second Row - Scrolling Right */}
      <motion.div
        className="flex gap-4"
        animate={{
          x: [-1600, 0],
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        {/* Duplicate the array 3 times for seamless endless effect */}
        {[...Array(3)].flatMap((_, set) =>
          mockUsers.map((user, i) => {
            const index = set * avatarCount + i;
            return (
              <motion.div
                key={`avatar-right-${index}`}
                className="w-14 h-14 md:w-20 md:h-20 rounded-full flex-shrink-0 flex items-center justify-center font-bold text-sm md:text-base relative group cursor-pointer"
                style={{
                  background: `linear-gradient(135deg, #F39C12 0%, #E67E22 100%)`,
                  border: `2px solid rgba(243, 156, 18, 0.4)`,
                  color: theme.colors.text,
                  boxShadow: `0 4px 12px rgba(243, 156, 18, 0.3), inset 0 1px 0 rgba(255,255,255,0.1)`,
                }}
                whileHover={{
                  scale: 1.1,
                  boxShadow: `0 6px 20px rgba(243, 156, 18, 0.5)`,
                }}
                transition={{ duration: 0.2 }}
                title={user.name}
              >
                {user.initials}
              </motion.div>
            );
          })
        )}
      </motion.div>

      {/* Dark Gradient Overlays - Disabled on mobile */}
      {!isMobile && (
        <>
          {/* Dark Gradient Overlays - Left Side */}
          <div 
            className="absolute inset-y-0 left-0 w-32 md:w-48 pointer-events-none z-10"
            style={{
              background: `linear-gradient(to right, ${theme.colors.bg} 0%, ${theme.colors.bg}F5 30%, ${theme.colors.bg}CC 60%, transparent 100%)`,
            }}
          />
          
          {/* Dark Gradient Overlays - Right Side */}
          <div 
            className="absolute inset-y-0 right-0 w-32 md:w-48 pointer-events-none z-10"
            style={{
              background: `linear-gradient(to left, ${theme.colors.bg} 0%, ${theme.colors.bg}F5 30%, ${theme.colors.bg}CC 60%, transparent 100%)`,
            }}
          />
        </>
      )}
    </div>
  );
};

export default AvatarScroll;

